import React from 'react';
import { AlertTriangle, RefreshCw, Bell } from 'lucide-react';

export default function LowStockAlertsPanel({ alerts, onRefresh }) {
  const criticalAlerts = alerts?.filter(a => a?.severity === 'critical');
  const warningAlerts = alerts?.filter(a => a?.severity === 'warning');

  return (
    <div className="bg-white rounded-lg shadow-sm border-2 border-orange-200 p-6 mb-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-orange-100 rounded-lg">
            <Bell size={20} className="text-orange-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Alertes Stock Bas</h2>
            <p className="text-sm text-gray-600">
              {criticalAlerts?.length} critique{criticalAlerts?.length > 1 ? 's' : ''} • {warningAlerts?.length} avertissement{warningAlerts?.length > 1 ? 's' : ''}
            </p>
          </div>
        </div>
        <button
          onClick={onRefresh}
          className="flex items-center gap-2 px-3 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
        >
          <RefreshCw size={16} />
          Actualiser
        </button>
      </div>

      {/* Alerts List */}
      <div className="space-y-3">
        {/* Critical Alerts */}
        {criticalAlerts?.length > 0 && (
          <div className="space-y-2">
            <h3 className="text-sm font-medium text-red-800 flex items-center gap-2">
              <AlertTriangle size={16} />
              Alertes Critiques
            </h3>
            {criticalAlerts?.map((alert, index) => (
              <div 
                key={index}
                className="bg-red-50 border border-red-200 rounded-lg p-4"
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="px-2 py-0.5 bg-red-600 text-white text-xs font-semibold rounded-full">
                        CRITIQUE
                      </span>
                      <span className="text-sm font-medium text-gray-900">{alert?.location}</span>
                    </div>
                    <p className="text-sm text-red-800 mb-2">{alert?.message}</p>
                    <div className="flex items-center gap-4 text-xs text-gray-600">
                      <span>Stock actuel: <span className="font-semibold text-red-700">{alert?.currentStock}</span></span>
                      <span>Seuil critique: <span className="font-semibold">{alert?.threshold}</span></span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <AlertTriangle size={24} className="text-red-600" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Warning Alerts */}
        {warningAlerts?.length > 0 && (
          <div className="space-y-2">
            <h3 className="text-sm font-medium text-yellow-800 flex items-center gap-2">
              <AlertTriangle size={16} />
              Avertissements
            </h3>
            {warningAlerts?.map((alert, index) => (
              <div 
                key={index}
                className="bg-yellow-50 border border-yellow-200 rounded-lg p-4"
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="px-2 py-0.5 bg-yellow-600 text-white text-xs font-semibold rounded-full">
                        ATTENTION
                      </span>
                      <span className="text-sm font-medium text-gray-900">{alert?.location}</span>
                    </div>
                    <p className="text-sm text-yellow-800 mb-2">{alert?.message}</p>
                    <div className="flex items-center gap-4 text-xs text-gray-600">
                      <span>Stock actuel: <span className="font-semibold text-yellow-700">{alert?.currentStock}</span></span>
                      <span>Seuil bas: <span className="font-semibold">{alert?.threshold}</span></span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <AlertTriangle size={24} className="text-yellow-600" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Summary */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Total des alertes actives</span>
          <span className="font-semibold text-gray-900">{alerts?.length}</span>
        </div>
      </div>
    </div>
  );
}